import * as api from '../../../clients/qschecks';

import {Action} from '@ngrx/store';

export const GET_UEBERSICHT = '[QschecksModul] GetUebersicht laden';
export const GET_UEBERSICHT_AUSFUEHREN = '[QschecksModul] GetUebersicht ausführen';
export const GET_UEBERSICHT_ERFOLGREICH = '[QschecksModul] GetUebersicht laden erfolgreich';
export const GET_UEBERSICHT_FEHLER = '[QschecksModul] GetUebersicht Ladefehler';
export const GET_UEBERSICHT_NICHT_AUSGEFUEHRT = '[QschecksModul] GetUebersicht nicht ausgeführt (evtl. Offline)';


export class GetUebersichtAction implements Action {
    readonly type = GET_UEBERSICHT;
        constructor(public uebersichtRequest: api.UebersichtRequest, public optPayload: any = null) {}
    }
export class GetUebersichtAusfuehrenAction implements Action {
    readonly type = GET_UEBERSICHT_AUSFUEHREN;
        constructor(public uebersichtRequest: api.UebersichtRequest, public optPayload: any = null) {}
    }
export class GetUebersichtErfolgreichAction implements Action {
    readonly type = GET_UEBERSICHT_ERFOLGREICH;
        constructor(public payload: api.Uebersicht, public uebersichtRequest: api.UebersichtRequest, public optPayload: any = null) {}
    }
export class GetUebersichtFehlerAction implements Action {
    readonly type = GET_UEBERSICHT_FEHLER;
        constructor(public payload: any, public uebersichtRequest: api.UebersichtRequest, public optPayload: any = null) {}
    }
export class GetUebersichtNichtAusgefuehrtAction implements Action {
    readonly type = GET_UEBERSICHT_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type QschecksCommandUebersichtActions =
    GetUebersichtAction
    | GetUebersichtAusfuehrenAction
    | GetUebersichtErfolgreichAction
    | GetUebersichtFehlerAction
    | GetUebersichtNichtAusgefuehrtAction
    ;
